module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/home-property-pin@2x-0e35fc7a0c9153a7e4ba21ec75746853.png";